<div class="work-ui-dropdown-list flex flex-column no-padding"
     [class.work-ui-dropdown-list--checkboxes]="withCheckboxes()">
  @if (listTitle() && checkboxesUseGroups()) {
    <div class="border-bottom padding-16">
      <div class="flex flex-row wrap space-between gap-24 vertical-center">
        <p><strong
          class="work-text-font-bold">{{ listTitle() | translate }}</strong>
        </p>
        @if (withCheckboxes()) {
          <div class="flex gap-4">
            <work-ui-button (buttonClick)="actionForAllCheckboxes('select')"
                            [disabled]="checkboxesSelectedAll"
                            size="small"
                            text="AUSWAEHLEN_ALLE"
                            variant="tertiary" />
            <work-ui-button (buttonClick)="actionForAllCheckboxes('deselect')"
                            [disabled]="checkboxesSelectedNone"
                            size="small"
                            text="ZURUECKSETZEN"
                            variant="tertiary" />
          </div>
        }
      </div>
    </div>
  }
  <div class="work-ui-dropdown-list__options">
    @if (withCheckboxes()) {
      @if (checkboxesUseGroups()) {
        <div class="groups">
          @for (group of getGroupObjectKeys(checkboxesGroupedOptions); track $index) {
            <div class="group-container padding-8">
              @if (isSingleSelectGroup(group)) {
                <div class="work-ui-dropdown-list__options-element no-border rounded padding-8">
                  <p><strong class="work-text-font-bold">{{ group | translate }}</strong></p>
                </div>
              } @else {
                <div (click)="toggleAllGroupOptions(group)"
                     class="work-ui-dropdown-list__options-element no-border work-action-element rounded">
                  <!-- Control ist rein dekorativ (pointer-events: none via SCSS); der Klick wird ausschliesslich vom umgebenden <div> verarbeitet. -->
                  <work-ui-checkbox [checked]="checkboxesGroupsState[group].allSelected"
                                    [labelBold]="true"
                                    [label]="group"
                                    [noMargin]="true" />
                </div>
              }
              <ul class="work-list width-100">
                @for (option of checkboxesGroupedOptions[group]; track $index) {
                  <ng-container *ngTemplateOutlet="optionTemplate; context: {$implicit: option}"></ng-container>
                }
              </ul>
            </div>
          }
        </div>
      } @else {
        <ul class="work-list padding-8 width-100">
          @for (option of checkboxOptionsState(); track $index) {
            <ng-container *ngTemplateOutlet="optionTemplate; context: {$implicit: option}"></ng-container>
          }
        </ul>
      }
      <ng-template #optionTemplate let-option>
        <!--
          Checkbox: rein dekorativ (pointer-events: none via SCSS), der <li>-Click verarbeitet den Klick
          genau einmal — möglich, weil der Checkbox-<input> inset:0 ist und die ganze Fläche abdeckt.
          Radio: der <input> ist 0x0, klickbar ist das Label → es braucht preventDefault/stopPropagation am
          Control selbst, sonst dispatcht das Label zusätzlich einen synthetischen Input-Click, der zum
          <li> hochbubbelt und selectCheckboxOption ein zweites Mal feuern (= wieder abwählen) liesse.
        -->
        <li (click)="selectCheckboxOption(option)"
            class="work-ui-dropdown-list__options-element no-border work-action-element rounded">
          <div [class.disabled]="option.disabled"
               class="width-100">
            @if (isSingleSelectGroup(option.group)) {
              <work-ui-radio-button (click)="$event.preventDefault(); $event.stopPropagation(); selectCheckboxOption(option)"
                                    [id]="'work-ui-dropdown-radio-' + (option.group || '') + '-' + option.value"
                                    [name]="option.group || ''"
                                    [value]="option.value"
                                    [selected]="option.selected || false"
                                    [label]="option.label"
                                    [noMargin]="true" />
            } @else {
              <work-ui-checkbox [checked]="option.selected || false"
                                [label]="option.label"
                                [noMargin]="true" />
            }
          </div>
        </li>
      </ng-template>
    }
    @if (!withCheckboxes()) {
      <ul class="work-list width-100 padding-8" role="listbox">
        @for (option of searchFilteredOptions(); track $index) {
          <li #listItem
              (pointermove)="selectedIndex.set( $index)"
              (click)="selectOption(option)"
              [class.focused]="selectedIndex() === $index && !preventActiveHighlighting()"
              [class.disabled]="option.disabled"
              role="option"
              class="work-ui-dropdown-list__options-element no-border work-action-element rounded no-hover-background">
            <div class="flex flex-row vertical-center gap-8">
              @if (option.iconName) {
                <work-ui-icon [name]="option.iconName" [fontSize]="22" />
              }
              <p class="work-text-font-regular"
                 [class.margin-top-4]="option.iconName">{{ option.label  | translate }}</p>
            </div>
          </li>
        } @empty {
          @if (activeStringValue()) {
            <p class="work-text-color-light work-text-align-center padding-48">
              <small>{{ 'KEINE_SUCHTREFFER' | translate }}</small>
            </p>
          }
        }
      </ul>
    }
  </div>
  @if (withCheckboxes() && !immediateApply() && (!hideCloseAction() || checkboxesHasChanges())) {
    <div class="padding-16 border-top">
      <work-ui-button (buttonClick)="acceptSelectedCheckboxOptions()"
                      [alignRight]="true"
                      [text]="!checkboxesHasChanges() ? 'SCHLIESSEN' : ('ANWENDEN' | translate) + ' (' + numberOfSelectedCheckboxes + ')'"
                      size="small" />
    </div>
  }
</div>

